<template>
  <svg viewBox="0 0 25 25" width="25" height="25" role="presentation">
    <circle fill="#d32f2f" cx="12.5" cy="12.5" r="12.5" />
    <path
      stroke="#fff"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="3"
      d="M8.346 8.346L17 17M16.654 8.346L8 17"
    />
  </svg>
</template>

<style scoped>
path {
  stroke: var(--bg-color);
}
</style>
